$('.card-overlay h3').fitText(1, {maxFontSize: '41px',});